// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3TraD","main":"style_main__1Gacr","button":"style_button__3CcFy","theme_selector_container":"style_theme_selector_container__Chrlc"};